import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { firstValueFrom, timeout } from 'rxjs';
import { UserStateSelectors } from '../../../../store/users-store/user.selectors';
import { getTenant } from '../../../services/global.service';

@Component({
  selector: 'app-route-permission-check',
  template: '',
  standalone: true,
})
export class RoutePermissionCheckComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly router = inject(Router);

  async ngOnInit(): Promise<void> {
    await new Promise((resolve) => setTimeout(resolve, 1000));

    const user = await this.getUserData();
    if (!user) {
      return;
    }

    const tenantRoutes = await this.getTenantRoutes();

    if (!tenantRoutes || tenantRoutes.length === 0) {
      return;
    }

    const currentPath = this.getCurrentRoutePath();

    if (currentPath === 'onboarding') {
      return;
    }

    const isAllowed = this.isRouteAllowed(currentPath, tenantRoutes);

    if (!isAllowed) {
      const redirectPath = this.getRedirectPathByPriority(tenantRoutes);
      this.router.navigate([redirectPath], { replaceUrl: true });
    }
  }

  private async getUserData(): Promise<unknown> {
    try {
      const user = await firstValueFrom(
        this.store.select(UserStateSelectors.getUser).pipe(timeout(5000)),
      );
      return user;
    } catch {
      return null;
    }
  }

  private async getTenantRoutes(): Promise<string[]> {
    try {
      const tenantRoutes = await firstValueFrom(
        this.store.select(UserStateSelectors.getTenantRoutes).pipe(timeout(5000)),
      );
      return tenantRoutes || [];
    } catch {
      return [];
    }
  }

  private getCurrentRoutePath(): string {
    const url = this.router.url;
    return url.startsWith('/') ? url.substring(1) : url;
  }

  private isRouteAllowed(routePath: string, tenantRoutes: string[]): boolean {
    if (tenantRoutes.includes(routePath)) {
      return true;
    }

    for (const tenantRoute of tenantRoutes) {
      if (routePath.startsWith(tenantRoute + '/') || routePath === tenantRoute) {
        return true;
      }
    }

    return false;
  }

  private getRedirectPathByPriority(tenantRoutes: string[]): string {
    const currentTenant = getTenant();
    const isDppTenant = currentTenant === 'dpp';

    if (tenantRoutes.includes('home')) {
      return '/home';
    }

    if (isDppTenant) {
      if (tenantRoutes.includes('dashboard')) {
        return '/dashboard';
      }
    } else {
      if (tenantRoutes.includes('dashboards')) {
        return '/dashboards';
      }
    }

    if (tenantRoutes.includes('products/list')) {
      return '/products/list';
    }

    return '/products/list';
  }
}
